// themeButton.js
import { useContext } from 'react';
import { IconButton } from '@mui/material';
import { Brightness4 } from '@mui/icons-material';
import { ColorModeContext } from '../contexts/ThemeContext';

export default function ThemeToggleButton() {
  const colorMode = useContext(ColorModeContext);

  return (
      <IconButton 
        onClick={colorMode.toggleColorMode} 
        color='primary' 
        variant="contained"
        sx={{paddingLeft: "12px", paddingRight: "12px"}}
      >
        <Brightness4 />
      </IconButton>
  );
}
